import Callback from '@/services/Callback'
import To from 'await-to-js'
import qs from 'qs'
import RecordOperation from '@/services/Record'
import { wizStandardInstance } from '@/services/instance'

export default class StdExtendAttributeMapping {
  static async getLabel(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdExtendAttributeMapping?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
}
